import { ButtonLink } from '@/components/ui'
import { SITE_NAME, usePageMeta } from '@/hooks'

/** 路由级 404。区别于「帖子不存在」——那由详情页自己处理，文案不同。 */
export function NotFoundPage() {
  usePageMeta({ title: `页面不存在 - ${SITE_NAME}`, noindex: true })

  return (
    <div className="mx-auto max-w-md py-20 text-center">
      <p className="font-mono text-4xl font-bold text-border-strong">404</p>
      <h1 className="mt-3 text-lg font-semibold text-foreground">页面不存在</h1>
      <p className="mt-2 text-sm leading-6 text-muted-foreground">
        地址可能输错了，或者这个页面已经被移除。
      </p>
      <div className="mt-5 flex justify-center gap-2 whitespace-nowrap">
        <ButtonLink to="/">返回首页</ButtonLink>
        <ButtonLink to="/search" variant="secondary">
          浏览资源
        </ButtonLink>
      </div>
    </div>
  )
}
